<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<blockquote epub:type="epigraph" role="doc-epigraph">
<p class="EP"><span aria-label="5" id="pg_5" role="doc-pagebreak"><i>Violence is the most elemental truth of life.</i></span></p>
<p class="EPC"><span class="small">JAMES CARLOS BLAKE</span></p>
</blockquote>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?29ae211a